import React, { FC } from 'react';

import demo from '@/public/images/theme_features/demo.svg';

import NextImage from '../UI/nextImage/NextImage';
import { Title } from '../UI/title/Title';

import styles from './DemoBlock.module.scss';

type TDemo = {
    demos: number;
};

const DemoBlock: FC<TDemo> = ({ demos }) => {
    return (
        <div className={styles.demos}>
            <div className={styles.demo__info}>
                <Title text="Multiple Demos in One Theme" size="sm" className={styles.heading} />
                <p className={`excerpt body-lg ${styles.excerpt}`}>
                    Choose from several distinct demos included within one comprehensive theme for a
                    custom fit for your site&apos;s style and purpose.
                </p>
            </div>

            <div className={styles.demo__wrapper}>
                <div className={styles.demo__main}>
                    <NextImage
                        src={demo.src}
                        alt="Demo"
                        fill
                        loading="lazy"
                        sizes="(max-width: 576px) 42vw, 300px"
                    />
                </div>
                {demos &&
                    [...new Array(6)].map((_, i) => (
                        <div
                            style={{
                                top: `${(i + 1) * 12}%`,
                                left: `${(i + 1) * 10}%`,
                                zIndex: `${7 - i}`,
                            }}
                            key={`demo-${i}`}
                            className={styles.demo__block}></div>
                    ))}
            </div>
            <div className={styles.demos__label}>
                <span className={styles.number}>{demos}</span>
                <span className={styles.descr}>{demos === 1 ? 'Demo' : 'Demos'}</span>
            </div>
        </div>
    );
};

export default DemoBlock;
